import { useCreateGitConfigMutation as _useCreateGitConfigMutation, useFetchGitBranchesLazyQuery as _useFetchGitBranchesLazyQuery, useGetAllOrgsListLazyQuery as _useGetAllOrgsListLazyQuery, useGetGitConfigLazyQuery as _useGetGitConfigLazyQuery, useResetGitConfigMutation as _useResetGitConfigMutation, useResetGitConfigWithOrgMutation as _useResetGitConfigWithOrgMutation, useUpdateGitConfigMutation as _useUpdateGitConfigMutation, } from '../generated/graphql-types';
export const useFetchGitBranches = () => {
    const [fetchBranches, { data, error, loading },] = _useFetchGitBranchesLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.VersionControl__fetchGitBranches,
        fetchBranches: (inputData) => fetchBranches({
            variables: {
                data: inputData,
            },
        }),
    };
};
export const useGetGitConfig = (request) => {
    const [fetchGitConfig, { data, error, loading },] = _useGetGitConfigLazyQuery({
        fetchPolicy: 'no-cache',
        variables: {
            data: {
                ...request,
                show_cluster_level_config: request?.show_cluster_level_config ?? false,
            },
        },
    });
    return {
        error,
        loading,
        data: data?.VersionControl__getGitConfig,
        fetchGitConfig: (inputData) => fetchGitConfig({
            variables: {
                data: {
                    ...inputData,
                    show_cluster_level_config: inputData?.show_cluster_level_config ?? false,
                },
            },
        }),
    };
};
export const useCreateGitConfig = () => {
    const [createGitConfigMutation, { data, error, loading },] = _useCreateGitConfigMutation();
    return {
        data: data?.VersionControl__createGitConfig,
        error,
        loading,
        createConfig: (inputData) => {
            return createGitConfigMutation({
                variables: { data: inputData },
            });
        },
    };
};
export const useUpdateGitConfig = () => {
    const [updateGitConfigMutaition, { data, error, loading },] = _useUpdateGitConfigMutation();
    return {
        data: data?.VersionControl__updateGitConfig,
        error,
        loading,
        updateConfig: (inputData) => {
            return updateGitConfigMutaition({
                variables: { data: inputData },
            });
        },
    };
};
export const useResetGitConfig = () => {
    const [resetGitConfigMutation, { data, error, loading },] = _useResetGitConfigMutation();
    return {
        data: data?.VersionControl__resetGitConfig,
        error,
        loading,
        resetConfig: (clusterLevel) => {
            return resetGitConfigMutation({
                variables: {
                    clusterLevel,
                },
            });
        },
    };
};
export const useGetAllOrgsListGit = () => {
    const [getAllOrgsListQuery, { data, error, loading },] = _useGetAllOrgsListLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        data: data?.getOrgsList,
        error,
        loading,
        getAllOrgsList: (input) => {
            return getAllOrgsListQuery({
                variables: { data: input },
            });
        },
    };
};
export const useResetGitConfigWithOrg = () => {
    const [useResetGitConfigWithOrgMutation, { data, error, loading },] = _useResetGitConfigWithOrgMutation();
    return {
        data: data?.VersionControl__resetGitConfigWithOrg,
        error,
        loading,
        resetConfigWithOrg: (orgIdentifier) => {
            return useResetGitConfigWithOrgMutation({
                variables: {
                    orgIdentifier,
                },
            });
        },
    };
};
//# sourceMappingURL=version-control.js.map